/** 回忆回看与站外相遇共用的只读气泡列表。 */

import type { ConversationMessage } from "@dreamverse/contracts";
import { MessageBubble } from "./MessageBubble";
import { SystemEventBar } from "./SystemEventBar";
import "./chat.css";

export function ReadOnlyConversationLog({
  messages,
  speakerName,
  avatarUrl,
}: {
  messages: readonly ConversationMessage[];
  speakerName: string;
  avatarUrl: string | null;
}) {
  return (
    <div className="conversation-log">
      {messages.map((message) =>
        message.role === "system" ? (
          <SystemEventBar key={message.id} message={message} />
        ) : (
          <MessageBubble
            key={message.id}
            entry={{ message }}
            speakerName={speakerName}
            avatarUrl={avatarUrl}
          />
        ),
      )}
    </div>
  );
}
